import styled from 'styled-components';

import arrowLeft from '~/assets/icon-arrow-left.png';
export const Container = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  z-index: 999;
  a {
    font-size: 0;
    display: block;
    width: 40px;
    height: 40px;
    background: url(${arrowLeft}) center no-repeat;
    background-size: contain;
    transform: rotate(-90deg);
    cursor: pointer;
  }
`;
